import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router=new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: ()=>import('@/views/index.vue'),
      meta:{title:'管理后台',unit:'首页'},
      children:[
        {
          path:'/',
          name:'HomePage',
          component: ()=>import('@/views/home/home.vue'),
          meta:{title:'管理后台',unit:'首页'},
          children:[
            {
              path: '/mail_list',
              name: 'mail_list',
              component: ()=>import('@/views/home/mail_list.vue'),
              meta:{title:'通讯录',unit:'首页'}
            },
            {
              path: '/set_shop',
              name: 'set_shop',
              component: ()=>import('@/views/home/set_shop.vue'),
              meta:{title:'开店宝配置',unit:'首页'}
            },
            {
              path: '/audit',
              name: 'audit',
              component: ()=>import('@/views/matters/audit.vue'),
              meta:{title:'账号审核',unit:'人事'}
            },
            {
              path: '/matters',
              name: 'matters',
              component: ()=>import('@/views/matters/matters.vue'),
              meta:{title:'系统角色管理',unit:'系统设置'}
            },
            {
              path: '/home_index',
              name: 'home_index',
              component: ()=>import('@/views/matters/home_index.vue'),
              meta:{title:'人事首页',unit:'人事'}
            },
            {
              path: '/clockLog',
              name: 'clockLog',
              component: ()=>import('@/views/matters/clockLog.vue'),
              meta:{title:'设备打卡日志',unit:'人事'}
            },
            {
              path: '/shop_manage',
              name: 'shop_manage',
              component: ()=>import('@/views/matters/shop_manage.vue'),
              meta:{title:'班次管理',unit:'人事'}
            },
            {
              path: '/post_manage',
              name: 'post_manage',
              component: ()=>import('@/views/matters/post_manage.vue'),
              meta:{title:'岗位管理',unit:'人事'}
            },
            {
              path: '/post_name',
              name: 'post_name',
              component: ()=>import('@/views/matters/post_name.vue'),
              meta:{title:'门店统一岗位列表',unit:'人事'}
            },
            {
              path: '/unit_manage',
              name: 'unit_manage',
              component: ()=>import('@/views/matters/unit_manage.vue'),
              meta:{title:'单位管理',unit:'人事'}
            },
            {
              path: '/jurisdiction_config',
              name: 'jurisdiction_config',
              component: ()=>import('@/views/matters/jurisdiction_config.vue'),
              meta:{title:'管辖范围配置',unit:'人事'}
            },
            {
              path: '/achievement',
              name: 'achievement',
              component: ()=>import('@/views/matters/achievement.vue'),
              meta:{title:'成就管理',unit:'人事'}
            },
            {
              path: '/medal',
              name: 'medal',
              component: ()=>import('@/views/matters/medal.vue'),
              meta:{title:'勋章管理',unit:'人事'}
            },
            {
              path: '/group_salary_manage',
              name: 'group_salary_manage',
              component: ()=>import('@/views/matters/salary/group_salary_manage.vue'),
              meta:{title:'集团薪酬项管理',unit:'人事'}
            },
            {
              path: '/group_salary_model_manage',
              name: 'group_salary_model_manage',
              component: ()=>import('@/views/matters/salary/group_salary_model_manage.vue'),
              meta:{title:'集团薪酬模板管理',unit:'人事'}
            },
            {
              path: '/salary_model_manage',
              name: 'salary_model_manage',
              component: ()=>import('@/views/matters/salary/salary_model_manage.vue'),
              meta:{title:'薪酬模板管理',unit:'人事'}
            },
            {
              path: '/salary_customized',
              name: 'salary_customized',
              component: ()=>import('@/views/matters/salary/salary_customized.vue'),
              meta:{title:'员工薪酬制定',unit:'人事'}
            },
            {
              path: '/salary_budget',
              name: 'salary_budget',
              component: ()=>import('@/views/matters/salary/salary_budget.vue'),
              meta:{title:'薪酬预算看板',unit:'人事'}
            },
            {
              path: '/salary_approval_management',
              name: 'salary_approval_management',
              component: ()=>import('@/views/matters/salary/salary_approval_management.vue'),
              meta:{title:'薪酬已审批管理',unit:'人事'}
            },
            {
              path: '/salary_wait_approval',
              name: 'salary_wait_approval',
              component: ()=>import('@/views/matters/salary/salary_approval_management.vue'),
              meta:{title:'薪酬待审批管理',unit:'人事'}
            },
            {
              path: '/salary_approval_process_set',
              name: 'salary_approval_process_set',
              component: ()=>import('@/views/matters/salary/salary_approval_process.vue'),
              meta:{title:'薪酬审批流程设置',unit:'人事'}
            },
            {
              path: '/salary_approval_process_manage',
              name: 'salary_approval_process_manage',
              component: ()=>import('@/views/matters/salary/salary_approval_process.vue'),
              meta:{title:'薪酬审批流程管理',unit:'人事'}
            },
            {
              path: '/group_PerfBudget_manage',
              name: 'group_PerfBudget_manage',
              component: ()=>import('@/views/matters/perf_budget/group_PerfBudget_manage.vue'),
              meta:{title:'集团绩效项管理',unit:'人事'}
            },
            {
              path: '/group_PerfBudget_model_manage',
              name: 'group_PerfBudget_model_manage',
              component: ()=>import('@/views/matters/perf_budget/group_PerfBudget_model_manage.vue'),
              meta:{title:'集团绩效模板管理',unit:'人事'}
            },
            {
              path: '/PerfBudget_model_manage',
              name: 'PerfBudget_model_manage',
              component: ()=>import('@/views/matters/perf_budget/PerfBudget_model_manage.vue'),
              meta:{title:'绩效模板管理',unit:'人事'}
            },
            {
              path: '/PerfBudget_customized',
              name: 'PerfBudget_customized',
              component: ()=>import('@/views/matters/perf_budget/PerfBudget_customized.vue'),
              meta:{title:'员工绩效制定',unit:'人事'}
            },
            {
              path: '/PerfBudget_budget',
              name: 'PerfBudget_budget',
              component: ()=>import('@/views/matters/perf_budget/PerfBudget_budget.vue'),
              meta:{title:'绩效预算看板',unit:'人事'}
            },
            {
              path: '/PerfBudget_approval_management',
              name: 'PerfBudget_approval_management',
              component: ()=>import('@/views/matters/perf_budget/PerfBudget_approval_management.vue'),
              meta:{title:'绩效审批管理',unit:'人事'}
            },
            {
              path: '/PerfBudget_approval_process_set',
              name: 'PerfBudget_approval_process_set',
              component: ()=>import('@/views/matters/perf_budget/PerfBudget_approval_process.vue'),
              meta:{title:'绩效审批流程设置',unit:'人事'}
            },
            {
              path: '/PerfBudget_approval_process_manage',
              name: 'PerfBudget_approval_process_manage',
              component: ()=>import('@/views/matters/perf_budget/PerfBudget_approval_process.vue'),
              meta:{title:'绩效审批流程管理',unit:'人事'}
            },
            {
              path: '/roster',
              name: 'roster',
              component: ()=>import('@/views/matters/roster.vue'),
              meta:{title:'人员管理',unit:'人事'}
            },
            {
              path: '/pre_employment',
              name: 'pre_employment',
              component: ()=>import('@/views/matters/pre_employment.vue'),
              meta:{title:'个人信息',unit:'首页'}
            },
            {
              path: '/formal_induction',
              name: 'formal_induction',
              component: ()=>import('@/views/matters/formal_induction.vue'),
              meta:{title:'正式入职',unit:'人事'}
            },
            {
              path: '/regular',
              name: 'regular',
              component: ()=>import('@/views/matters/regular.vue'),
              meta:{title:'转正',unit:'人事'}
            },
            {
              path: '/quit_work',
              name: 'quit_work',
              component: ()=>import('@/views/matters/quit_work.vue'),
              meta:{title:'离职',unit:'人事'}
            },
            {
              path: '/job_transfer',
              name: 'job_transfer',
              component: ()=>import('@/views/matters/job_transfer.vue'),
              meta:{title:'岗位调动',unit:'人事'}
            },
            {
              path: '/reward_and_punishment',
              name: 'reward_and_punishment',
              component: ()=>import('@/views/matters/reward_and_punishment.vue'),
              meta:{title:'奖励惩罚',unit:'人事'}
            },
            {
              path: '/r_p_common_list',
              name: '/r_p_common_list',
              component: ()=>import('@/views/matters/r_p_list.vue'),
              meta:{title:'奖惩列表',unit:'人事'}
            },
            {
              path: '/r_p_type',
              name: '/r_p_type',
              component: ()=>import('@/views/matters/r_p_type.vue'),
              meta:{title:'奖惩类别管理',unit:'人事'}
            },
            {
              path: '/r_p_audit_list',
              name: '/r_p_audit_list',
              component: ()=>import('@/views/matters/r_p_list.vue'),
              meta:{title:'奖惩审核列表',unit:'人事'}
            },
            {
              path: '/jurisdiction',
              name: 'jurisdiction',
              component: ()=>import('@/views/matters/jurisdiction.vue'),
              meta:{title:'管辖范围',unit:'人事'}
            },
            {
              path: '/grant',
              name: 'grant',
              component: ()=>import('@/views/task/grant.vue'),
              meta:{title:'成就授予',unit:'人事'}
            },
            {
              path: '/light_medal',
              name: 'light_medal',
              component: ()=>import('@/views/task/light_medal.vue'),
              meta:{title:'人工点亮',unit:'人事'}
            },
            {
              path: '/peopleDetail',
              name: 'peopleDetail',
              component: ()=>import('@/views/matters/peopleDetail.vue'),
              meta:{title:'人员详情',unit:'人事'}
            },
            {
              path: '/shop_scheduling',
              name: 'shop_scheduling',
              component: ()=>import('@/views/matters/shop_scheduling.vue'),
              meta:{title:'门店排班',unit:'人事'}
            },
            {
              path: '/agent_management',
              name: 'agent_management',
              component: ()=>import('@/views/matters/agent_management.vue'),
              meta:{title:'代理商管理',unit:'人事'}
            },
            {
              path: '/storePriceZoning',
              name: 'storePriceZoning',
              component: ()=>import('@/views/matters/storePriceZoning.vue'),
              meta:{title:'门店价格分区',unit:'人事'}
            },
            {
              path: '/approval_settings',
              name: 'approval_settings',
              component: ()=>import('@/views/matters/business_trip_management/approval_settings.vue'),
              meta:{title:'人事审批设置',unit:'人事'}
            },
            {
              path: '/business_trip_application',
              name: 'business_trip_application',
              component: ()=>import('@/views/matters/business_trip_management/BusinessTrip.vue'),
              meta:{title:'出差申请',unit:'人事'}
            },
            {
              path: '/business_trip_approval',
              name: 'business_trip_approval',
              component: ()=>import('@/views/matters/business_trip_management/BusinessTrip.vue'),
              meta:{title:'出差审批',unit:'人事'}
            },
            {
              path: '/archive_approval_settings',
              name: 'archive_approval_settings',
              component: ()=>import('@/views/matters/file_management/archive_approval_settings.vue'),
              meta:{title:'档案审批设置',unit:'人事'}
            },
            {
              path: '/regularization_reminder',
              name: 'regularization_reminder',
              component: ()=>import('@/views/matters/file_management/regularization_reminder.vue'),
              meta:{title:'转正提醒',unit:'人事'}
            },
            {
              path: '/archive_application',
              name: 'archive_application',
              component: ()=>import('@/views/matters/file_management/archive_application_and_approval.vue'),
              meta:{title:'档案申请',unit:'人事'}
            },
            {
              path: '/archive_approval',
              name: 'archive_approval',
              component: ()=>import('@/views/matters/file_management/archive_application_and_approval.vue'),
              meta:{title:'档案审批',unit:'人事'}
            },
            {
              path: '/archive_details',
              name: 'archive_details',
              component: ()=>import('@/views/matters/file_management/archive_details.vue'),
              meta:{title:'档案详情',unit:'人事'}
            },
            {
              path: '/approval',
              name: 'approval',
              component: ()=>import('@/views/task/approval.vue'),
              meta:{title:'任务审批',unit:'任务'}
            },
            {
              path: '/basic_settings',
              name: 'basic_settings',
              component: ()=>import('@/views/task/basic_settings.vue'),
              meta:{title:'任务基础设置',unit:'任务'}
            },
            {
              path: '/taskList',
              name: 'taskList',
              component: ()=>import('@/views/task/taskList.vue'),
              meta:{title:'任务列表',unit:'任务'}
            },
            {
              path: '/task_details',
              name: 'task_details',
              component: ()=>import('@/views/task/task_details.vue'),
              meta:{title:'任务详情',unit:'任务'}
            },
            {
              path: '/taskSetting',
              name: 'taskSetting',
              component: ()=>import('@/views/task/taskSetting.vue'),
              meta:{title:'审批流程配置',unit:'任务'}
            },
            {
              path: '/full_synchronization',
              name: 'full_synchronization',
              component: ()=>import('@/views/task/full_synchronization.vue'),
              meta:{title:'新店全面同步',unit:'任务'}
            },
            {
              path: '/task_board',
              name: 'task_board',
              component: ()=>import('@/views/task/task_board.vue'),
              meta:{title:'任务完成情况看板',unit:'任务'}
            },
            {
              path: '/tools_setting',
              name: 'tools_setting',
              component: ()=>import('@/views/supply/shopping/shopping_setting.vue'),
              meta:{title:'基础设置',unit:'运营小工具'}
            },
            {
              path: '/class_manage',
              name: 'class_manage',
              component: ()=>import('@/views/tools/customClassification/class_manage.vue'),
              meta:{title:'自创分类管理',unit:'运营小工具'}
            },
            {
              path: '/inventory_created_items',
              name: 'inventory_created_items',
              component: ()=>import('@/views/tools/customClassification/inventory_created_items.vue'),
              meta:{title:'盘点自创品项',unit:'运营小工具'}
            },
            {
              path: '/simple_inventory_table',
              name: 'simple_inventory_table',
              component: ()=>import('@/views/tools/customClassification/simple_inventory_table.vue'),
              meta:{title:'盘点表',unit:'运营小工具'}
            },
            {
              path: '/receipt_and_storage',
              name: 'receipt_and_storage',
              component: ()=>import('@/views/tools/customClassification/receipt_and_storage.vue'),
              meta:{title:'收货入库',unit:'运营小工具'}
            },
            {
              path: '/dish_basic_data',
              name: 'dish_basic_data',
              component: ()=>import('@/views/tools/dish_basic_data.vue'),
              meta:{title:'菜品基础资料',unit:'运营小工具'}
            },
            {
              path: '/dish_name',
              name: 'dish_name',
              component: ()=>import('@/views/tools/dish_name.vue'),
              meta:{title:'菜品收银系统名称规整',unit:'运营小工具'}
            },
            {
              path: '/standardMark',
              name: 'standardMark',
              component: ()=>import('@/views/tools/standardMark.vue'),
              meta:{title:'总部菜品名称对应基准表',unit:'运营小工具'}
            },
            {
              path: '/DishesCardAliasList',
              name: 'DishesCardAliasList',
              component: ()=>import('@/views/tools/DishesCardAliasList.vue'),
              meta:{title:'统一菜品做法名称对应基准',unit:'运营小工具'}
            },
            {
              path: '/item_basic_data',
              name: 'item_basic_data',
              component: ()=>import('@/views/tools/item_basic_data.vue'),
              meta:{title:'品项基础资料',unit:'运营小工具'}
            },
            {
              path: '/combination_master_data',
              name: 'combination_master_data',
              component: ()=>import('@/views/tools/combination_master_data.vue'),
              meta:{title:'组合品项基础资料',unit:'运营小工具'}
            },
            {
              path: '/dish_card',
              name: 'dish_card',
              component: ()=>import('@/views/tools/dish_card.vue'),
              meta:{title:'菜品组成卡',unit:'运营小工具'}
            },
            {
              path: '/warehouse_settings',
              name: 'warehouse_settings',
              component: ()=>import('@/views/tools/warehouse_settings.vue'),
              meta:{title:'品项仓库设置',unit:'运营小工具'}
            },
            {
              path: '/inventory',
              name: 'inventory',
              component: ()=>import('@/views/tools/inventory.vue'),
              meta:{title:'盘点历史',unit:'运营小工具'}
            },
            {
              path: '/alarm_line',
              name: 'alarm_line',
              component: ()=>import('@/views/tools/alarm_line.vue'),
              meta:{title:'库存报警线',unit:'运营小工具'}
            },
            {
              path: '/inventory_summary',
              name: 'inventory_summary',
              component: ()=>import('@/views/tools/inventory_summary.vue'),
              meta:{title:'简易盘点汇总',unit:'运营小工具'}
            },
            {
              path: '/store_ingredient_archives',
              name: 'store_ingredient_archives',
              component: ()=>import('@/views/tools/store_ingredient_archives.vue'),
              meta:{title:'门店食材档案',unit:'运营小工具'}
            },
            {
              path: '/loss_summary',
              name: 'loss_summary',
              component: ()=>import('@/views/tools/loss_summary.vue'),
              meta:{title:'门店损耗汇总',unit:'运营小工具'}
            },
            {
              path: '/item_disassembly',
              name: 'item_disassembly',
              component: ()=>import('@/views/tools/item_disassembly.vue'),
              meta:{title:'品项组合拆解折算',unit:'运营小工具'}
            },
            {
              path: '/calculated_consumption',
              name: 'calculated_consumption',
              component: ()=>import('@/views/tools/calculated_consumption.vue'),
              meta:{title:'按销量推算理论用量',unit:'仪表盘'}
            },
            {
              path: '/price_manage',
              name: 'price_manage',
              component: ()=>import('@/views/tools/price_manage.vue'),
              meta:{title:'组成卡相关品项价格管理',unit:'运营小工具'}
            },
            {
              path: '/profit_calculation',
              name: 'profit_calculation',
              component: ()=>import('@/views/tools/theoreticalProfit/profit_calculation.vue'),
              meta:{title:'理论毛利值测算',unit:'运营小工具'}
            },
            {
              path: '/profit_details',
              name: 'profit_details',
              component: ()=>import('@/views/tools/theoreticalProfit/profit_details.vue'),
              meta:{title:'理论毛利值测算详情',unit:'运营小工具'}
            },
            {
              path: '/menu_template',
              name: 'menu_template',
              component: ()=>import('@/views/tools/theoreticalProfit/menu_template.vue'),
              meta:{title:'菜单模板',unit:'运营小工具'}
            },
            {
              path: '/shop_menu_choose',
              name: 'shop_menu_choose',
              component: ()=>import('@/views/tools/theoreticalProfit/shop_menu_choose.vue'),
              meta:{title:'门店菜单选择',unit:'运营小工具'}
            },
            {
              path: '/sales_data_entry',
              name: 'sales_data_entry',
              component: ()=>import('@/views/tools/analysisAndCalculation/sales_data_entry.vue'),
              meta:{title:'门店营业数据录入',unit:'运营小工具'}
            },
            {
              path: '/profit_analysis_data',
              name: 'profit_analysis_data',
              component: ()=>import('@/views/tools/analysisAndCalculation/profit_analysis_data.vue'),
              meta:{title:'毛利分析数据',unit:'运营小工具'}
            },
            {
              path: '/consumption_comparison',
              name: 'consumption_comparison',
              component: ()=>import('@/views/tools/analysisAndCalculation/consumption_comparison.vue'),
              meta:{title:'品项消耗对比测算',unit:'运营小工具'}
            },
            {
              path: '/NonStandardDish',
              name: 'NonStandardDish',
              component: ()=>import('@/views/tools/NonStandardDish.vue'),
              meta:{title:'非标菜品资料',unit:'运营小工具'}
            },
            {
              path: '/NonStandardConsumption',
              name: 'NonStandardConsumption',
              component: ()=>import('@/views/tools/NonStandardConsumption.vue'),
              meta:{title:'非标菜品消耗',unit:'运营小工具'}
            },
            {
              path: '/BeefCutTypeList',
              name: 'BeefCutTypeList',
              component: ()=>import('@/views/tools/BeefRegistrationForm/BeefCutTypeList.vue'),
              meta:{title:'牛肉分肉类型设置',unit:'运营小工具'}
            },
            {
              path: '/enterBeef',
              name: 'enterBeef',
              component: ()=>import('@/views/tools/BeefRegistrationForm/enterBeef.vue'),
              meta:{title:'牛肉订货到货',unit:'运营小工具'}
            },
            {
              path: '/MeatManagement',
              name: 'MeatManagement',
              component: ()=>import('@/views/tools/BeefRegistrationForm/enterBeef.vue'),
              meta:{title:'分部位肉管理',unit:'运营小工具'}
            },
            {
              path: '/BeefDishes',
              name: 'BeefDishes',
              component: ()=>import('@/views/tools/BeefRegistrationForm/enterBeef.vue'),
              meta:{title:'自采牛肉菜品',unit:'运营小工具'}
            },
            {
              path: '/beefAnalysis',
              name: 'beefAnalysis',
              component: ()=>import('@/views/tools/BeefRegistrationForm/beefAnalysis.vue'),
              meta:{title:'数据分析',unit:'运营小工具'}
            },
            {
              path: '/invoiceApproval',
              name: 'invoiceApproval',
              component: ()=>import('@/views/finance/invoiceManagement/invoiceInformation.vue'),
              meta:{title:'发票审批',unit:'财务'}
            },
            {
              path: '/invoiceApplication',
              name: 'invoiceApplication',
              component: ()=>import('@/views/finance/invoiceManagement/invoiceInformation.vue'),
              meta:{title:'发票申请',unit:'财务'}
            },
            {
              path: '/invoiceInformation',
              name: 'invoiceInformation',
              component: ()=>import('@/views/finance/invoiceManagement/invoiceInformation.vue'),
              meta:{title:'发票信息',unit:'财务'}
            },
            {
              path: '/invoiceList',
              name: 'invoiceList',
              component: ()=>import('@/views/finance/invoiceManagement/invoiceList.vue'),
              meta:{title:'开票信息管理',unit:'财务'}
            },
            {
              path: '/uploadInvoice',
              name: 'uploadInvoice',
              component: ()=>import('@/views/finance/invoiceManagement/uploadInvoice.vue'),
              meta:{title:'上传发票',unit:'财务'}
            },
            {
              path: '/depart_report',
              name: 'depart_report',
              component: ()=>import('@/views/finance/depart_report.vue'),
              meta:{title:'门店报表',unit:'财务'}
            },
            {
              path: '/subject_manage',
              name: 'subject_manage',
              component: ()=>import('@/views/finance/subject_manage.vue'),
              meta:{title:'支出科目管理',unit:'财务'}
            },
            {
              path: '/revice_subject_manage',
              name: 'revice_subject_manage',
              component: ()=>import('@/views/finance/revice_subject_manage.vue'),
              meta:{title:'收入科目管理',unit:'财务'}
            },
            {
              path: '/set_opening',
              name: 'set_opening',
              component: ()=>import('@/views/finance/set_opening.vue'),
              meta:{title:'设置期初',unit:'财务'}
            },
            {
              path: '/item_manage',
              name: 'item_manage',
              component: ()=>import('@/views/finance/item_manage.vue'),
              meta:{title:'品项管理',unit:'财务'}
            },
            {
              path: '/reimbursement_list',
              name: 'reimbursement_list',
              component: ()=>import('@/views/finance/reimbursement_list.vue'),
              meta:{title:'报销单',unit:'财务'}
            },
            {
              path: '/my_reimbursement_list',
              name: 'my_reimbursement_list',
              component: ()=>import('@/views/finance/reimbursement_list.vue'),
              meta:{title:'我的报销单',unit:'财务'}
            },
            {
              path: '/acceptance_form_management',
              name: 'acceptance_form_management',
              component: ()=>import('@/views/finance/acceptance_form_management.vue'),
              meta:{title:'入库验收单管理',unit:'财务'}
            },
            {
              path: '/acceptance_form_audit',
              name: 'acceptance_form_audit',
              component: ()=>import('@/views/finance/acceptance_form_audit.vue'),
              meta:{title:'入库验收单审核',unit:'财务'}
            },
            {
              path: '/ticket_management',
              name: 'ticket_management',
              component: ()=>import('@/views/finance/ticket_management.vue'),
              meta:{title:'到票管理',unit:'财务'}
            },
            {
              path: '/ticket_audit',
              name: 'ticket_audit',
              component: ()=>import('@/views/finance/ticket_audit.vue'),
              meta:{title:'到票审核',unit:'财务'}
            },
            {
              path: '/new_reimbursement',
              name: 'new_reimbursement',
              component: ()=>import('@/views/finance/new_reimbursement.vue'),
              meta:{title:'新增报销单',unit:'财务'}
            },
            {
              path: '/reimbursement_detail',
              name: 'reimbursement_detail',
              component: ()=>import('@/views/finance/reimbursement_detail.vue'),
              meta:{title:'报销单详情',unit:'财务'}
            },
            {
              path: '/approve_list',
              name: 'approve_list',
              component: ()=>import('@/views/finance/approve_list.vue'),
              meta:{title:'审批列表',unit:'财务'}
            },
            {
              path: '/wait_approve_list',
              name: 'wait_approve_list',
              component: ()=>import('@/views/finance/approve_list.vue'),
              meta:{title:'待审批列表',unit:'财务'}
            },
            {
              path: '/has_approve_list',
              name: 'has_approve_list',
              component: ()=>import('@/views/finance/approve_list.vue'),
              meta:{title:'已审批列表',unit:'财务'}
            },
            {
              path: '/has_reject_list',
              name: 'has_reject_list',
              component: ()=>import('@/views/finance/approve_list.vue'),
              meta:{title:'已驳回列表',unit:'财务'}
            },
            {
              path: '/wait_pay_list',
              name: 'wait_pay_list',
              component: ()=>import('@/views/finance/pay_list.vue'),
              meta:{title:'待支付管理（立即）',unit:'财务'}
            },
            {
              path: '/plan_pay_list',
              name: 'plan_pay_list',
              component: ()=>import('@/views/finance/pay_list.vue'),
              meta:{title:'待支付管理（排期）',unit:'财务'}
            },
            {
              path: '/has_pay_list',
              name: 'has_pay_list',
              component: ()=>import('@/views/finance/has_paid_list.vue'),
              meta:{title:'已支付列表',unit:'财务'}
            },
            {
              path: '/icome_confirm',
              name: 'icome_confirm',
              component: ()=>import('@/views/finance/icome_confirm.vue'),
              meta:{title:'收入确认科目',unit:'财务'}
            },
            {
              path: '/periodic_statistics',
              name: 'periodic_statistics',
              component: ()=>import('@/views/finance/periodic_statistics.vue'),
              meta:{title:'支出周期统计',unit:'财务'}
            },
            {
              path: '/periodic_details',
              name: 'periodic_details',
              component: ()=>import('@/views/finance/periodic_details.vue'),
              meta:{title:'周期统计详情(支出)',unit:'财务'}
            },
            {
              path: '/revice_periodic_statistics',
              name: 'revice_periodic_statistics',
              component: ()=>import('@/views/finance/revice_periodic_statistics.vue'),
              meta:{title:'收入周期统计',unit:'财务'}
            },
            {
              path: '/revice_periodic_details',
              name: 'revice_periodic_details',
              component: ()=>import('@/views/finance/revice_periodic_details.vue'),
              meta:{title:'周期统计详情(收入)',unit:'财务'}
            },
            {
              path: '/comparative_analysis',
              name: 'comparative_analysis',
              component: ()=>import('@/views/finance/comparative_analysis.vue'),
              meta:{title:'支出对比分析',unit:'财务'}
            },
            {
              path: '/revice_comparative_analysis',
              name: 'revice_comparative_analysis',
              component: ()=>import('@/views/finance/revice_comparative_analysis.vue'),
              meta:{title:'收入对比分析',unit:'财务'}
            },
            {
              path: '/subject_sorting',
              name: 'subject_sorting',
              component: ()=>import('@/views/finance/subject_sorting.vue'),
              meta:{title:'支出科目展示排序',unit:'财务'}
            },
            {
              path: '/revice_subject_sorting',
              name: 'revice_subject_sorting',
              component: ()=>import('@/views/finance/revice_subject_sorting.vue'),
              meta:{title:'收入科目展示排序',unit:'财务'}
            },
            {
              path: '/valuable_assets',
              name: 'valuable_assets',
              component: ()=>import('@/views/finance/valuable_assets.vue'),
              meta:{title:'核心资产报表',unit:'财务'}
            },
            {
              path: '/contract_price_management',
              name: 'contract_price_management',
              component: ()=>import('@/views/finance/contractPrice/contract_price_management.vue'),
              meta:{title:'合约价管理',unit:'财务'}
            },
            {
              path: '/payment_bank_account',
              name: 'payment_bank_account',
              component: ()=>import('@/views/finance/payment_bank_account.vue'),
              meta:{title:'付款银行账户',unit:'财务'}
            },
            {
              path: '/bank_branch_entry',
              name: 'bank_branch_entry',
              component: ()=>import('@/views/finance/bank_branch_entry.vue'),
              meta:{title:'银行网点录入',unit:'财务'}
            },
            {
              path: '/yongyou_dictionary',
              name: 'yongyou_dictionary',
              component: ()=>import('@/views/finance/yongyou_dictionary.vue'),
              meta:{title:'用友编码数据管理',unit:'财务'}
            },
            {
              path: '/set_validation',
              name: 'set_validation',
              component: ()=>import('@/views/finance/contractPrice/set_validation.vue'),
              meta:{title:'设置需验证单位',unit:'财务'}
            },
            {
              path: '/approval_process_set',
              name: 'approval_process_set',
              component: ()=>import('@/views/finance/approval_process.vue'),
              meta:{title:'审批流程设置',unit:'财务'}
            },
            {
              path: '/approval_process_manage',
              name: 'approval_process_manage',
              component: ()=>import('@/views/finance/approval_process.vue'),
              meta:{title:'审批流程管理',unit:'财务'}
            },
            {
              path: '/dual_system',
              name: 'dual_system',
              component: ()=>import('@/views/headquarters/dual_system.vue'),
              meta:{title:'双系统门店管理',unit:'仪表盘'}
            },
            {
              path: '/additional_turnover',
              name: 'additional_turnover',
              component: ()=>import('@/views/headquarters/additional_turnover.vue'),
              meta:{title:'补录营业额',unit:'仪表盘'}
            },
            {
              path: '/save_replenish_arrival',
              name: 'save_replenish_arrival',
              component: ()=>import('@/views/headquarters/save_replenish_arrival.vue'),
              meta:{title:'补录到账金额',unit:'仪表盘'}
            },
            {
              path: '/everyday',
              name: 'everyday',
              component: ()=>import('@/views/headquarters/everyday.vue'),
              meta:{title:'每日原始数据',unit:'仪表盘'}
            },
            {
              path: '/key_monitoring',
              name: 'key_monitoring',
              component: ()=>import('@/views/supply/shopOrder/key_monitoring.vue'),
              meta:{title:'重点食材监控明细',unit:'仪表盘'}
            },
            {
              path: '/big_key_monitoring',
              name: 'big_key_monitoring',
              component: ()=>import('@/views/headquarters/big_key_monitoring.vue'),
              meta:{title:'监控大屏(任意时间)',unit:'仪表盘'}
            },
            {
              path: '/fast_anticipation',
              name: 'fast_anticipation',
              component: ()=>import('@/views/headquarters/fast_anticipation.vue'),
              meta:{title:'监控大屏(快速预判)',unit:'仪表盘'}
            },
            {
              path: '/sales_statistics',
              name: 'sales_statistics',
              component: ()=>import('@/views/headquarters/sales_statistics.vue'),
              meta:{title:'菜品销量统计',unit:'仪表盘'}
            },
            {
              path: '/beef_statistics',
              name: 'beef_statistics',
              component: ()=>import('@/views/headquarters/beef_statistics.vue'),
              meta:{title:'牛杂煲口味统计',unit:'仪表盘'}
            },
            {
              path: '/shop_average',
              name: 'shop_average',
              component: ()=>import('@/views/headquarters/shop_average.vue'),
              meta:{title:'门店锅均量',unit:'仪表盘'}
            },
            {
              path: '/shop_operation',
              name: 'shop_operation',
              component: ()=>import('@/views/headquarters/shop_operation.vue'),
              meta:{title:'门店经营',unit:'仪表盘'}
            },
            {
              path: '/shop_evaluate',
              name: 'shop_evaluate',
              component: ()=>import('@/views/headquarters/shop_evaluate.vue'),
              meta:{title:'门店平台评价',unit:'仪表盘'}
            },
            {
              path: '/boss_report',
              name: 'boss_report',
              component: ()=>import('@/views/headquarters/boss_report.vue'),
              meta:{title:'老板周报/月报',unit:'仪表盘'}
            },
            {
              path: '/behavior_tracking',
              name: 'behavior_tracking',
              component: ()=>import('@/views/headquarters/behavior_tracking.vue'),
              meta:{title:'行为跟踪',unit:'仪表盘'},
            },
            {
              path: '/data_pull',
              name: 'data_pull',
              component: ()=>import('@/views/headquarters/data_pull.vue'),
              meta:{title:'同步美团数据',unit:'仪表盘'}
            },
            {
              path: '/pot_average',
              name: 'pot_average',
              component: ()=>import('@/views/headquarters/pot_average.vue'),
              meta:{title:'锅均量报表',unit:'仪表盘'}
            },
            {
              path: '/evaluate',
              name: 'evaluate',
              component: ()=>import('@/views/headquarters/evaluate.vue'),
              meta:{title:'大众美团评价',unit:'仪表盘'}
            },
            {
              path: '/rating_settings',
              name: 'rating_settings',
              component: ()=>import('@/views/headquarters/rating_settings.vue'),
              meta:{title:'营业额评级设置',unit:'仪表盘'}
            },
            {
              path: '/store_rating',
              name: 'store_rating',
              component: ()=>import('@/views/headquarters/store_rating.vue'),
              meta:{title:'门店评级大屏',unit:'仪表盘'}
            },
            {
              path: '/store_score',
              name: 'store_score',
              component: ()=>import('@/views/headquarters/store_score.vue'),
              meta:{title:'门店评分大屏',unit:'仪表盘'}
            },
            {
              path: '/purchase_zero',
              name: 'purchase_zero',
              component: ()=>import('@/views/headquarters/purchase_zero.vue'),
              meta:{title:'重点食材门店采购零值表',unit:'仪表盘'}
            },
            {
              path: '/revenue_cycle',
              name: 'revenue_cycle',
              component: ()=>import('@/views/headquarters/revenue_cycle.vue'),
              meta:{title:'门店营收周期数据',unit:'仪表盘'}
            },
            {
              path: '/package_sales_details',
              name: 'package_sales_details',
              component: ()=>import('@/views/headquarters/package_sales_details.vue'),
              meta:{title:'套餐销售数据',unit:'仪表盘'}
            },
            {
              path: '/store_information',
              name: 'store_information',
              component: ()=>import('@/views/headquarters/store_information.vue'),
              meta:{title:'门店资料',unit:'仪表盘'}
            },
            {
              path: '/after_sales_category',
              name: 'after_sales_category',
              component: ()=>import('@/views/afterSales/after_sales_category.vue'),
              meta:{title:'售后分类',unit:'供应链'}
            },
            {
              path: '/after_sales_total',
              name: 'after_sales_total',
              component: ()=>import('@/views/afterSales/after_sales_list.vue'),
              meta:{title:'售后单汇总',unit:'供应链'}
            },
            {
              path: '/my_after_sales',
              name: 'my_after_sales',
              component: ()=>import('@/views/afterSales/after_sales_list.vue'),
              meta:{title:'我的售后单',unit:'供应链'}
            },
            {
              path: '/large_screen',
              name: 'large_screen',
              component: ()=>import('@/views/afterSales/large_screen.vue'),
              meta:{title:'售后(退款)监控大屏',unit:'供应链'}
            },
            {
              path: '/supplier_roster',
              name: 'supplier_roster',
              component: ()=>import('@/views/afterSales/supplier_roster.vue'),
              meta:{title:'产品供应链花名册',unit:'供应链'}
            },
            {
              path: '/warehouse_list',
              name: 'warehouse_list',
              component: ()=>import('@/views/supply/warehouse/warehouse_list.vue'),
              meta:{title:'仓库列表',unit:'供应链'}
            },
            {
              path: '/inventory_statistics_table',
              name: 'inventory_statistics_table',
              component: ()=>import('@/views/supply/warehouse/inventory_statistics_table.vue'),
              meta:{title:'出入库统计表',unit:'供应链'}
            },
            {
              path: '/view_opening',
              name: 'view_opening',
              component: ()=>import('@/views/supply/warehouse/view_opening.vue'),
              meta:{title:'查看期初',unit:'供应链',from:'/warehouse_list'}
            },
            {
              path: '/view_inventory',
              name: 'view_inventory',
              component: ()=>import('@/views/supply/warehouse/view_opening.vue'),
              meta:{title:'库存查询',unit:'供应链',from:'/warehouse_list'}
            },
            {
              path: '/goods_management',
              name: 'goods_management',
              component: ()=>import('@/views/supply/warehouse/view_opening.vue'),
              meta:{title:'货位管理',unit:'供应链',from:'/warehouse_list'}
            },
            {
              path: '/access_history',
              name: 'access_history',
              component: ()=>import('@/views/supply/warehouse/access_history.vue'),
              meta:{title:'出入库历史',unit:'供应链',from:'/warehouse_list'}
            },
            {
              path: '/warehouse_manage',
              name: 'warehouse_manage',
              component: ()=>import('@/views/supply/warehouse/warehouse_manage.vue'),
              meta:{title:'出入库管理',unit:'供应链',from:'/warehouse_list'}
            },
            {
              path: '/third_flyer',
              name: 'third_flyer',
              component: ()=>import('@/views/supply/warehouse/third_flyer.vue'),
              meta:{title:'出入库回传订单检验',unit:'供应链'}
            },
            {
              path: '/flyer_details',
              name: 'flyer_details',
              component: ()=>import('@/views/supply/warehouse/flyer_details.vue'),
              meta:{title:'回传订单详情',unit:'供应链'}
            },
            {
              path: '/application_form',
              name: 'application_form',
              component: ()=>import('@/views/supply/warehouse/application_form.vue'),
              meta:{title:'出入库申请单',unit:'供应链',from:'/warehouse_list'}
            },
            {
              path: '/initiate_reimbursement',
              name: 'initiate_reimbursement',
              component: ()=>import('@/views/supply/warehouse/initiate_reimbursement.vue'),
              meta:{title:'智能报销',unit:'供应链'}
            },
            {
              path: '/access_details',
              name: 'access_details',
              component: ()=>import('@/views/supply/warehouse/access_details.vue'),
              meta:{title:'出入库详情',unit:'供应链',from:'/warehouse_list'}
            },
            {
              path: '/data_dictionary',
              name: 'data_dictionary',
              component: ()=>import('@/views/supply/warehouse/data_dictionary.vue'),
              meta:{title:'数据字典',unit:'供应链'}
            },
            {
              path: '/silent_item',
              name: 'silent_item',
              component: ()=>import('@/views/supply/warehouse/silent_item.vue'),
              meta:{title:'沉默品项监控',unit:'供应链'}
            },
            {
              path: '/pickup_list',
              name: 'pickup_list',
              component: ()=>import('@/views/supply/warehouse/pickup_list.vue'),
              meta:{title:'自提订单管理',unit:'供应链'}
            },
            {
              path: '/warehouse_order',
              name: 'warehouse_order',
              component: ()=>import('@/views/supply/warehouse/warehouse_order.vue'),
              meta:{title:'仓库订单',unit:'供应链'}
            },
            {
              path: '/warehouse_order_detail',
              name: 'warehouse_order_detail',
              component: ()=>import('@/views/supply/warehouse/warehouse_order_detail.vue'),
              meta:{title:'仓库订单详情',unit:'供应链',from:'/warehouse_order'}
            },
            {
              path: '/audit_inventory',
              name: 'audit_inventory',
              component: ()=>import('@/views/supply/warehouse/audit_inventory.vue'),
              meta:{title:'审计盘点',unit:'供应链',from:'/warehouse_list'}
            },
            {
              path: '/audit_inventory_details',
              name: 'audit_inventory_details',
              component: ()=>import('@/views/supply/warehouse/audit_inventory_details.vue'),
              meta:{title:'审计盘点详情',unit:'供应链',from:'/warehouse_list'}
            },
            {
              path: '/audit_start',
              name: 'audit_start',
              component: ()=>import('@/views/supply/warehouse/audit_start.vue'),
              meta:{title:'发起审计盘点',unit:'供应链',from:'/warehouse_list'}
            },
            {
              path: '/auditing',
              name: 'auditing',
              component: ()=>import('@/views/supply/warehouse/audit_start.vue'),
              meta:{title:'审计盘点进行中',unit:'供应链',from:'/warehouse_list'}
            },
            {
              path: '/shopping_setting',
              name: 'shopping_setting',
              component: ()=>import('@/views/supply/shopping/shopping_setting.vue'),
              meta:{title:'商城基础设置',unit:'供应链'}
            },
            {
              path: '/shopping_list',
              name: 'shopping_list',
              component: ()=>import('@/views/supply/shopping/shopping_list.vue'),
              meta:{title:'商城列表',unit:'供应链'}
            },
            {
              path: '/shopping_column',
              name: 'shopping_column',
              component: ()=>import('@/views/supply/shopping/shopping_column.vue'),
              meta:{title:'商城栏目管理',unit:'供应链',from:'/shopping_list'}
            },
            {
              path: '/shelf_management',
              name: 'shelf_management',
              component: ()=>import('@/views/supply/shopping/shelf_management.vue'),
              meta:{title:'上下架管理',unit:'供应链',from:'/shopping_list'}
            },
            {
              path: '/combination_shelf_management',
              name: 'combination_shelf_management',
              component: ()=>import('@/views/supply/shopping/combination_shelf_management.vue'),
              meta:{title:'组合销售上下架管理',unit:'供应链',from:'/shopping_list'}
            },
            {
              path: '/shopping_order',
              name: 'shopping_order',
              component: ()=>import('@/views/supply/shopping/shopping_order.vue'),
              meta:{title:'商城订单管理',unit:'供应链'}
            },
            {
              path: '/orderDetail_list',
              name: 'orderDetail_list',
              component: ()=>import('@/views/supply/shopping/orderDetail_list.vue'),
              meta:{title:'商城订单明细',unit:'供应链'}
            },
            {
              path: '/logisticsItemDetails',
              name: 'logisticsItemDetails',
              component: ()=>import('@/views/supply/shopping/logisticsItemDetails.vue'),
              meta:{title:'物流到货查询',unit:'供应链'}
            },
            {
              path: '/shopping_order_detail',
              name: 'shopping_order_detail',
              component: ()=>import('@/views/supply/shopping/shopping_order_detail.vue'),
              meta:{title:'商城订单详情',unit:'供应链',from:'/shopping_order'}
            },
            {
              path: '/shopping_recharge',
              name: 'shopping_recharge',
              component: ()=>import('@/views/supply/shopping/shopping_recharge.vue'),
              meta:{title:'综合管理',unit:'供应链'}
            },
            {
              path: '/store_bag_enter',
              name: 'store_bag_enter',
              component: ()=>import('@/views/supply/shopping/store_bag_enter.vue'),
              meta:{title:'门店美团钱包ID录入',unit:'供应链'}
            },
            {
              path: '/bank_wallet_list',
              name: 'bank_wallet_list',
              component: ()=>import('@/views/supply/shopping/bank_wallet_list.vue'),
              meta:{title:'收款银行美团钱包ID录入',unit:'供应链'}
            },
            {
              path: '/bag_records',
              name: 'bag_records',
              component: ()=>import('@/views/supply/shopping/bag_records.vue'),
              meta:{title:'美团钱包流水',unit:'供应链'}
            },
            {
              path: '/bag_table',
              name: 'bag_table',
              component: ()=>import('@/views/supply/shopping/bag_table.vue'),
              meta:{title:'美团钱包统计',unit:'供应链'}
            },
            {
              path: '/recharge_order',
              name: 'recharge_order',
              component: ()=>import('@/views/supply/shopping/recharge_order.vue'),
              meta:{title:'充值订单',unit:'供应链'}
            },
            {
              path: '/recharge_history',
              name: 'recharge_history',
              component: ()=>import('@/views/supply/shopping/recharge_history.vue'),
              meta:{title:'充值历史',unit:'供应链'}
            },
            {
              path: '/shopping_details',
              name: 'shopping_details',
              component: ()=>import('@/views/supply/shopping/shopping_details.vue'),
              meta:{title:'商城详情',unit:'供应链',from:'/shopping_recharge'}
            },
            {
              path: '/rebate_management',
              name: 'rebate_management',
              component: ()=>import('@/views/supply/shopping/rebate_management.vue'),
              meta:{title:'返点管理',unit:'供应链'}
            },
            {
              path: '/item_class',
              name: 'item_class',
              component: ()=>import('@/views/supply/items/item_class.vue'),
              meta:{title:'品项分类',unit:'供应链'}
            },
            {
              path: '/item_collection',
              name: 'item_collection',
              component: ()=>import('@/views/supply/items/item_collection.vue'),
              meta:{title:'品项集合管理',unit:'供应链'}
            },
            {
              path: '/item_list',
              name: 'item_list',
              component: ()=>import('@/views/supply/items/item_list.vue'),
              meta:{title:'品项列表',unit:'供应链'}
            },
            {
              path: '/payment_to_be_confirmed',
              name: 'payment_to_be_confirmed',
              component: ()=>import('@/views/supply/offline_payment/confirm_payment_order_list.vue'),
              meta:{title:'待确认付款订单',unit:'供应链'}
            },
            {
              path: '/refund_to_be_confirmed',
              name: 'refund_to_be_confirmed',
              component: ()=>import('@/views/supply/offline_payment/confirm_payment_order_list.vue'),
              meta:{title:'待确认退款订单',unit:'供应链'}
            },
            {
              path: '/payment_to_be_reviewed',
              name: 'payment_to_be_reviewed',
              component: ()=>import('@/views/supply/offline_payment/pending_order_list.vue'),
              meta:{title:'待审核付款订单',unit:'供应链'}
            },
            {
              path: '/refund_to_be_reviewed',
              name: 'refund_to_be_reviewed',
              component: ()=>import('@/views/supply/offline_payment/pending_order_list.vue'),
              meta:{title:'待审核退款订单',unit:'供应链'}
            },
            {
              path: '/approved_payment',
              name: 'approved_payment',
              component: ()=>import('@/views/supply/offline_payment/approved_order_list.vue'),
              meta:{title:'已审核付款订单',unit:'供应链'}
            },
            {
              path: '/refund_approved',
              name: 'refund_approved',
              component: ()=>import('@/views/supply/offline_payment/approved_order_list.vue'),
              meta:{title:'已审核退款订单',unit:'供应链'}
            },
            {
              path: '/offline_details',
              name: 'offline_details',
              component: ()=>import('@/views/supply/offline_payment/offline_details.vue'),
              meta:{title:'线下付款订单详情',unit:'供应链'}
            },
            {
              path: '/my_order',
              name: 'my_order',
              component: ()=>import('@/views/supply/shopOrder/my_order.vue'),
              meta:{title:'我的订单',unit:'供应链'}
            },
            {
              path: '/out_purchase',
              name: 'out_purchase',
              component: ()=>import('@/views/supply/shopOrder/out_purchase.vue'),
              meta:{title:'外采虚拟订单',unit:'供应链'}
            },
            {
              path: '/shop_overview',
              name: 'shop_overview',
              component: ()=>import('@/views/supply/shopOrder/shop_overview.vue'),
              meta:{title:'商城总概况',unit:'供应链'}
            },
            {
              path: '/shop_sales_volume',
              name: 'shop_sales_volume',
              component: ()=>import('@/views/supply/shopOrder/shop_sales_volume.vue'),
              meta:{title:'门店销售额',unit:'供应链'}
            },
            {
              path: '/shop_sales_rank',
              name: 'shop_sales_rank',
              component: ()=>import('@/views/supply/shopOrder/shop_sales_rank.vue'),
              meta:{title:'商城销售排行',unit:'供应链'}
            },
            {
              path: '/monitoring_samples',
              name: 'monitoring_samples',
              component: ()=>import('@/views/supply/shopOrder/monitoring_samples.vue'),
              meta:{title:'重点食材监控样本',unit:'供应链'}
            },
            {
              path: '/sales_and_delivery',
              name: 'sales_and_delivery',
              component: ()=>import('@/views/supply/data_comparison/sales_and_delivery.vue'),
              meta:{title:'商城销售与出库数据对比',unit:'供应链'}
            },
            {
              path: '/dedicated_logistics',
              name: 'dedicated_logistics',
              component: ()=>import('@/views/supply/data_comparison/dedicated_logistics.vue'),
              meta:{title:'专配物流信息反馈',unit:'供应链',keepAlive:true}
            },
            {
              path: '/operation_monitoring',
              name: 'operation_monitoring',
              component: ()=>import('@/views/supply/shopOrder/operation_monitoring.vue'),
              meta:{title:'采购运营监控',unit:'供应链'}
            },
            {
              path: '/purchase_item_details',
              name: 'purchase_item_details',
              component: ()=>import('@/views/supply/shopOrder/purchase_item_details.vue'),
              meta:{title:'采购品项明细',unit:'供应链'}
            },
            {
              path: '/item_area',
              name: 'item_area',
              component: ()=>import('@/views/supply/items/item_area.vue'),
              meta:{title:'品项适用范围',unit:'供应链'}
            },
            {
              path: '/supplier_manage',
              name: 'supplier_manage',
              component: ()=>import('@/views/supply/supplier/supplier_manage'),
              meta:{title:'供应商管理',unit:'供应链'}
            },
            {
              path: '/logistics_statistics',
              name: 'logistics_statistics',
              component: ()=>import('@/views/supply/shopOrder/logistics_statistics'),
              meta:{title:'发货物流统计表',unit:'供应链',keepAlive:true}
            },
            {
              path: '/own_inventory',
              name: 'own_inventory',
              component: ()=>import('@/views/supply/stock_calculation/own_inventory'),
              meta:{title:'自有库存品项管理',unit:'供应链'}
            },
            {
              path: '/set_self_owned',
              name: 'set_self_owned',
              component: ()=>import('@/views/supply/stock_calculation/set_self_owned'),
              meta:{title:'设置自有库存品项',unit:'供应链'}
            },
            {
              path: '/inventory_difference',
              name: 'inventory_difference',
              component: ()=>import('@/views/supply/stock_calculation/inventory_difference'),
              meta:{title:'查看库存差值',unit:'供应链'}
            },
            {
              path: '/coupon_dictionary',
              name: 'coupon_dictionary',
              component: ()=>import('@/views/supply/coupon/coupon_dictionary'),
              meta:{title:'优惠券相关字典',unit:'供应链'}
            },
            {
              path: '/coupon_manage',
              name: 'coupon_manage',
              component: ()=>import('@/views/supply/coupon/coupon_manage'),
              meta:{title:'优惠券管理',unit:'供应链'}
            },
            {
              path: '/distribution_be_approved',
              name: 'distribution_be_approved',
              component: ()=>import('@/views/supply/coupon/distribution_be_approved'),
              meta:{title:'派发待审批',unit:'供应链'}
            },
            {
              path: '/my_coupon',
              name: 'my_coupon',
              component: ()=>import('@/views/supply/coupon/my_coupon'),
              meta:{title:'我的优惠券',unit:'供应链'}
            },
            {
              path: '/coupon_use_details',
              name: 'coupon_use_details',
              component: ()=>import('@/views/supply/coupon/coupon_use_details'),
              meta:{title:'优惠券使用详情',unit:'供应链',keepAlive:true}
            },
            {
              path: '/coupon_approval_process_set',
              name: 'coupon_approval_process_set',
              component: ()=>import('@/views/supply/coupon/coupon_process.vue'),
              meta:{title:'优惠券审批流程设置',unit:'供应链'}
            },
            {
              path: '/coupon_audit_list',
              name: 'coupon_audit_list',
              component: ()=>import('@/views/supply/coupon/coupon_audit_list.vue'),
              meta:{title:'我的优惠券审核列表',unit:'供应链'}
            },
            {
              path: '/statistics_of_used_stores',
              name: 'statistics_of_used_stores',
              component: ()=>import('@/views/supply/coupon/statistics_of_used_stores'),
              meta:{title:'商城已使用统计表',unit:'供应链'}
            },
            {
              path: '/store_unused_statistics',
              name: 'store_unused_statistics',
              component: ()=>import('@/views/supply/coupon/store_unused_statistics'),
              meta:{title:'门店未使用统计表',unit:'供应链'}
            },
            {
              path: '/summary_of_procurement_amount',
              name: 'summary_of_procurement_amount',
              component: ()=>import('@/views/supply/shopOrder/summary_of_procurement_amount'),
              meta:{title:'采购额汇总监控大屏',unit:'供应链'}
            },
            {
              path: '/supplyPersonnelList',
              name: 'supplyPersonnelList',
              component: ()=>import('@/views/matters/personnelList'),
              meta:{title:'人员名单',unit:'供应链'}
            },
            {
              path: '/applyType',
              name: 'applyType',
              component: ()=>import('@/views/checkWork/applyType'),
              meta:{title:'请假类型设置',unit:'人事'}
            },
            {
              path: '/basicSetting',
              name: 'basicSetting',
              component: ()=>import('@/views/checkWork/basicSetting'),
              meta:{title:'考勤基础设置',unit:'人事'}
            },
            {
              path: '/audit_card',
              name: 'audit_card',
              component: ()=>import('@/views/checkWork/review_application'),
              meta:{title:'审核补卡申请',unit:'人事'}
            },
            {
              path: '/audit_overtime',
              name: 'audit_overtime',
              component: ()=>import('@/views/checkWork/review_application'),
              meta:{title:'审核加班申请',unit:'人事'}
            },
            {
              path: '/audit_leave',
              name: 'audit_leave',
              component: ()=>import('@/views/checkWork/review_application'),
              meta:{title:'审核补请假',unit:'人事'}
            },
            {
              path: '/punch_record',
              name: 'punch_record',
              component: ()=>import('@/views/checkWork/punch_record'),
              meta:{title:'打卡原始记录',unit:'人事'}
            },
            {
              path: '/monthly_statistics',
              name: 'monthly_statistics',
              component: ()=>import('@/views/checkWork/monthly_statistics'),
              meta:{title:'月统计',unit:'人事'}
            },
            {
              path: '/group_social_manage',
              name: 'group_social_manage',
              component: ()=>import('@/views/matters/social_security/group_social_manage'),
              meta:{title:'系统社保公积金项管理',unit:'人事'}
            },
            {
              path: '/group_social_model_manage',
              name: 'group_social_model_manage',
              component: ()=>import('@/views/matters/social_security/group_social_model_manage'),
              meta:{title:'系统社保公积金模板管理',unit:'人事'}
            },
            {
              path: '/social_model_manage',
              name: 'social_model_manage',
              component: ()=>import('@/views/matters/social_security/social_model_manage'),
              meta:{title:'各单位社保公积金模块管理',unit:'人事'}
            },
            {
              path: '/social_customized',
              name: 'social_customized',
              component: ()=>import('@/views/matters/social_security/social_customized'),
              meta:{title:'员工社保公积金制定',unit:'人事'}
            },
            {
              path: '/rank_manage',
              name: 'rank_manage',
              component: ()=>import('@/views/matters/rank/rank_manage'),
              meta:{title:'职级管理',unit:'人事'}
            },
            {
              path: '/scheduling_board',
              name: 'scheduling_board',
              component: ()=>import('@/views/matters/scheduling_board'),
              meta:{title:'直营门店排班考勤看板',unit:'人事'}
            },
            {
              path: '/personnelList',
              name: 'personnelList',
              component: ()=>import('@/views/matters/personnelList'),
              meta:{title:'人员名单',unit:'人事'}
            },
            {
              path: '/HeadquartersInspectionItems',
              name: 'HeadquartersInspectionItems',
              component: ()=>import('@/views/onSite/InspectManage'),
              meta:{title:'总部巡检项',unit:'巡检'}
            },
            {
              path: '/CustomizedInspectionItems',
              name: 'CustomizedInspectionItems',
              component: ()=>import('@/views/onSite/InspectManage'),
              meta:{title:'门店自定义巡检项',unit:'巡检'}
            },
            {
              path: '/HeadquartersInspectionList',
              name: 'HeadquartersInspectionList',
              component: ()=>import('@/views/onSite/InspectManage'),
              meta:{title:'总部巡检表列表',unit:'巡检'}
            },
            {
              path: '/CustomizedInspectionList',
              name: 'CustomizedInspectionList',
              component: ()=>import('@/views/onSite/InspectManage'),
              meta:{title:'门店自定义巡检表管理',unit:'巡检'}
            },
            {
              path: '/onsiteSetting',
              name: 'onsiteSetting',
              component: ()=>import('@/views/onSite/onsiteSetting'),
              meta:{title:'巡检基础设置',unit:'巡检'}
            },
            {
              path: '/onsiteList',
              name: 'onsiteList',
              component: ()=>import('@/views/onSite/onsiteList'),
              meta:{title:'巡检表管理',unit:'巡检'}
            },
            {
              path: '/onsiteHistory',
              name: 'onsiteHistory',
              component: ()=>import('@/views/onSite/onsiteHistory'),
              meta:{title:'巡检历史',unit:'巡检'}
            },
            {
              path: '/onsiteHistory_detail',
              name: 'onsiteHistory_detail',
              component: ()=>import('@/views/onSite/onsiteHistory_detail'),
              meta:{title:'巡检历史详情',unit:'巡检'}
            },
            {
              path: '/statistical_report',
              name: 'statistical_report',
              component: ()=>import('@/views/onSite/statistical_report'),
              meta:{title:'巡检报告统计',unit:'巡检'}
            },
            {
              path: '/common_problem',
              name: 'common_problem',
              component: ()=>import('@/views/onSite/common_problem'),
              meta:{title:'巡检常见问题统计',unit:'巡检',keepAlive:true}
            },
            {
              path: '/common_problem_detail',
              name: 'common_problem_detail',
              component: ()=>import('@/views/onSite/onsiteHistory_detail'),
              meta:{title:'巡检项列表扣分详情',unit:'巡检'}
            },
            {
              path: '/rectification_analysis',
              name: 'rectification_analysis',
              component: ()=>import('@/views/onSite/rectification_analysis'),
              meta:{title:'整改分析',unit:'巡检'}
            },
            {
              path: '/rectification_details',
              name: 'rectification_details',
              component: ()=>import('@/views/onSite/rectification_details'),
              meta:{title:'整改详情',unit:'巡检'}
            },
            {
              path: '/punish_type',
              name: 'punish_type',
              component: ()=>import('@/views/onSite/punishManage'),
              meta:{title:'处罚类型',unit:'巡检'}
            },
            {
              path: '/punish_reason',
              name: 'punish_reason',
              component: ()=>import('@/views/onSite/punishManage'),
              meta:{title:'处罚原因',unit:'巡检'}
            },
            {
              path: '/store_punish',
              name: 'store_punish',
              component: ()=>import('@/views/onSite/store_punish'),
              meta:{title:'巡检门店处罚',unit:'巡检'}
            },
            {
              path: '/punish_audit',
              name: 'punish_audit',
              component: ()=>import('@/views/onSite/punish_audit'),
              meta:{title:'处罚发布审批',unit:'巡检'}
            },
            {
              path: '/my_punish',
              name: 'my_punish',
              component: ()=>import('@/views/onSite/my_punish'),
              meta:{title:'我的处罚单',unit:'巡检'}
            },
            {
              path: '/my_fb_punish',
              name: 'my_fb_punish',
              component: ()=>import('@/views/onSite/my_fb_punish'),
              meta:{title:'我的处罚反馈',unit:'巡检'}
            },
            {
              path: '/standard_setting_for_onsite',
              name: 'standard_setting_for_onsite',
              component: ()=>import('@/views/onSite/standard_setting_for_onsite'),
              meta:{title:'巡检执行标准设置',unit:'巡检'}
            },
            {
              path: '/store_execution_standards',
              name: 'store_execution_standards',
              component: ()=>import('@/views/onSite/store_execution_standards'),
              meta:{title:'门店执行标准大屏',unit:'巡检'}
            },
            {
              path: '/onsiteScheduling',
              name: 'onsiteScheduling',
              component: ()=>import('@/views/onSite/onsiteScheduling'),
              meta:{title:'巡检排班',unit:'巡检'}
            },
            {
              path: '/deviceManagement',
              name: 'deviceManagement',
              component: ()=>import('@/views/onSite/deviceManagement'),
              meta:{title:'设备管理',unit:'巡检'}
            },
            {
              path: '/videoManage',
              name: 'videoManage',
              component: ()=>import('@/views/onSite/videoManage'),
              meta:{title:'视频巡检任务管理',unit:'巡检'}
            },
            {
              path: '/aiInspect',
              name: 'aiInspect',
              component: ()=>import('@/views/onSite/aiInspect'),
              meta:{title:'AI监控报告',unit:'巡检'}
            },
            {
              path: '/videoInspect',
              name: 'videoInspect',
              component: ()=>import('@/views/onSite/videoInspect'),
              meta:{title:'视频巡检报告',unit:'巡检'}
            },
            {
              path: '/leave_msg',
              name: 'leave_msg',
              component: ()=>import('@/views/attract/leave_msg'),
              meta:{title:'官网留言',unit:'招商'}
            },
            {
              path: '/operation_overview',
              name: 'operation_overview',
              component: ()=>import('@/views/attract/operation_overview'),
              meta:{title:'门店经营概况',unit:'招商'}
            },
            {
              path: '/standard_name',
              name: 'standard_name',
              component: ()=>import('@/views/contract/standard_name'),
              meta:{title:'标准合同名称管理',unit:'合同'}
            },
            {
              path: '/personnel_name',
              name: 'personnel_name',
              component: ()=>import('@/views/contract/personnel_name'),
              meta:{title:'人事合同名称管理',unit:'合同'}
            },
            {
              path: '/standard_contract',
              name: 'standard_contract',
              component: ()=>import('@/views/contract/standard_contract'),
              meta:{title:'标准合同管理',unit:'合同'}
            },
            {
              path: '/personnel_contract',
              name: 'personnel_contract',
              component: ()=>import('@/views/contract/personnel_contract'),
              meta:{title:'人事合同管理',unit:'合同'}
            },
            {
              path: '/not_standard_contract',
              name: 'not_standard_contract',
              component: ()=>import('@/views/contract/not_standard_contract'),
              meta:{title:'非标合同管理',unit:'合同'}
            },
            {
              path: '/all_contract',
              name: 'all_contract',
              component: ()=>import('@/views/contract/all_contract'),
              meta:{title:'全部合同列表',unit:'合同'}
            },
            {
              path: '/calendar',
              name: 'calendar',
              component: ()=>import('@/views/headquarters/calendar'),
              meta:{title:'工作日历',unit:'工作日历'}
            },
            {
              path: '/operational_allocation',
              name: 'operational_allocation',
              component: ()=>import('@/views/operationManagement/operational_allocation'),
              meta:{title:'门店运营分配',unit:'运营管理'}
            },
            {
              path: '/target_setting',
              name: 'target_setting',
              component: ()=>import('@/views/operationManagement/target_setting'),
              meta:{title:'门店目标设定',unit:'运营管理'}
            },
            {
              path: '/enter_score',
              name: 'enter_score',
              component: ()=>import('@/views/headquarters/enter_score.vue'),
              meta:{title:'门店补录评分数据',unit:'运营管理'}
            },
            {
              path: '/general_overview',
              name: 'general_overview',
              component: ()=>import('@/views/operationManagement/general_overview'),
              meta:{title:'总体概况',unit:'运营管理'}
            },
            {
              path: '/overview_operators',
              name: 'overview_operators',
              component: ()=>import('@/views/operationManagement/overview_operators'),
              meta:{title:'运营人员概况',unit:'运营管理'}
            },
            {
              path: '/store_monthly_report',
              name: 'store_monthly_report',
              component: ()=>import('@/views/operationManagement/store_monthly_report'),
              meta:{title:'门店数据月汇报',unit:'运营管理'}
            },
            {
              path: '/data_generation_record',
              name: 'data_generation_record',
              component: ()=>import('@/views/operationManagement/data_generation_record'),
              meta:{title:'门店数据周报生成记录',unit:'运营管理'}
            },
            {
              path: '/data_my_record',
              name: 'data_my_record',
              component: ()=>import('@/views/operationManagement/data_generation_record'),
              meta:{title:'我生成的汇报',unit:'运营管理'}
            },
            {
              path: '/operational_jurisdiction',
              name: 'operational_jurisdiction',
              component: ()=>import('@/views/operationManagement/operational_jurisdiction'),
              meta:{title:'运营管辖分区',unit:'运营管理'}
            },
            {
              path: '/production_link',
              name: 'production_link',
              component: ()=>import('@/views/workshopProduction/production_link'),
              meta:{title:'生产环节管理',unit:'车间生产'}
            },
            {
              path: '/production_type',
              name: 'production_type',
              component: ()=>import('@/views/workshopProduction/production_type'),
              meta:{title:'生产类型管理',unit:'车间生产'}
            },
            {
              path: '/production_model_type',
              name: 'production_model_type',
              component: ()=>import('@/views/workshopProduction/production_model_type'),
              meta:{title:'生产模板类型管理',unit:'车间生产'}
            },
            {
              path: '/production_hours',
              name: 'production_hours',
              component: ()=>import('@/views/workshopProduction/production_hours'),
              meta:{title:'生产工时管理',unit:'车间生产'}
            },
            {
              path: '/production_template',
              name: 'production_template',
              component: ()=>import('@/views/workshopProduction/production_template'),
              meta:{title:'品项生产模板管理',unit:'车间生产'}
            },
            {
              path: '/production_list',
              name: 'production_list',
              component: ()=>import('@/views/workshopProduction/production_list'),
              meta:{title:'生产任务列表',unit:'车间生产'}
            },
            {
              path: '/production_cost_monitoring',
              name: 'production_cost_monitoring',
              component: ()=>import('@/views/workshopProduction/production_cost_monitoring'),
              meta:{title:'生产成本波动监控',unit:'车间生产'}
            },
            {
              path: '/workflow_type',
              name: 'workflow_type',
              component: ()=>import('@/views/workflow/workflow_type'),
              meta:{title:'工作流类型管理',unit:'工作流'}
            },
            {
              path: '/workflow_position',
              name: 'workflow_position',
              component: ()=>import('@/views/workflow/workflow_position'),
              meta:{title:'工作流岗位管理',unit:'工作流'}
            },
            {
              path: '/workflow_templates',
              name: 'workflow_templates',
              component: ()=>import('@/views/workflow/workflow_templates'),
              meta:{title:'工作流模板管理',unit:'工作流'}
            },
            {
              path: '/workflow_list',
              name: 'workflow_list',
              component: ()=>import('@/views/workflow/workflow_list'),
              meta:{title:'工作流列表',unit:'工作流'}
            },
            {
              path: '/my_workflow',
              name: 'my_workflow',
              component: ()=>import('@/views/workflow/my_workflow'),
              meta:{title:'我的工作流',unit:'工作流'}
            },
            {
              path: '/workflow_analysis',
              name: 'workflow_analysis',
              component: ()=>import('@/views/workflow/workflow_analysis'),
              meta:{title:'工作流统计分析',unit:'工作流'}
            },
            {
              path: '/create_recommend',
              name: 'create_recommend',
              component: ()=>import('@/views/orderRecommend/create_recommend'),
              meta:{title:'【推荐下单】任务',unit:'下单推荐'}
            },
            {
              path: '/recommend_list',
              name: 'recommend_list',
              component: ()=>import('@/views/orderRecommend/recommend_list'),
              meta:{title:'【推荐下单】任务列表',unit:'下单推荐'}
            },
            {
              path: '/message_basic_settings',
              name: 'message_basic_settings',
              component: ()=>import('@/views/notify/message_basic_settings'),
              meta:{title:'消息基础设置',unit:'消息通知'}
            },
            {
              path: '/message_list',
              name: 'message_list',
              component: ()=>import('@/views/notify/message_list'),
              meta:{title:'全部通知',unit:'消息通知'}
            },
            {
              path: '/my_message_list',
              name: 'my_message_list',
              component: ()=>import('@/views/notify/message_list'),
              meta:{title:'我创建的消息',unit:'消息通知'}
            },
            {
              path: '/new_message',
              name: 'new_message',
              component: ()=>import('@/views/notify/new_message'),
              meta:{title:'新建消息',unit:'消息通知'}
            },
            {
              path: '/audit_list',
              name: 'audit_list',
              component: ()=>import('@/views/notify/audit_list'),
              meta:{title:'审核列表',unit:'消息通知'}
            },
            {
              path: '/msg_details',
              name: 'msg_details',
              component: ()=>import('@/views/notify/msg_details'),
              meta:{title:'消息详情',unit:'消息通知'}
            },
            {
              path: '/feedback_audit',
              name: 'feedback_audit',
              component: ()=>import('@/views/notify/feedback_audit'),
              meta:{title:'签阅反馈看板',unit:'消息通知'}
            },
            {
              path: '/mandatory_message',
              name: 'mandatory_message',
              component: ()=>import('@/views/notify/feedback_audit'),
              meta:{title:'门店必读消息',unit:'消息通知'}
            },
            {
              path: '/feedback_detail_list',
              name: 'feedback_detail_list',
              component: ()=>import('@/views/notify/feedback_detail_list'),
              meta:{title:'签阅反馈审核详情',unit:'消息通知'}
            },
            {
              path: '/feedback_details',
              name: 'feedback_details',
              component: ()=>import('@/views/notify/feedback_details'),
              meta:{title:'反馈详情',unit:'消息通知'}
            },
            {
              path: '/demand_list',
              name: 'demand_list',
              component: ()=>import('@/views/procurement/demand_list'),
              meta:{title:'采购需求单',unit:'采购管理'}
            },
            {
              path: '/my_demand_list',
              name: 'my_demand_list',
              component: ()=>import('@/views/procurement/demand_list'),
              meta:{title:'我的采购需求单',unit:'采购管理'}
            },
            {
              path: '/new_demand',
              name: 'new_demand',
              component: ()=>import('@/views/procurement/new_demand'),
              meta:{title:'新建需求单',unit:'采购管理'}
            },
            {
              path: '/demand_details',
              name: 'demand_details',
              component: ()=>import('@/views/procurement/demand_details'),
              meta:{title:'需求单详情',unit:'采购管理'}
            },
            {
              path: '/audit_demand_list',
              name: 'audit_demand_list',
              component: ()=>import('@/views/procurement/audit_demand_list'),
              meta:{title:'待审批管理',unit:'采购管理'}
            },
            {
              path: '/has_audit_demand_list',
              name: 'has_audit_demand_list',
              component: ()=>import('@/views/procurement/audit_demand_list'),
              meta:{title:'已审批管理',unit:'采购管理'}
            },
            {
              path: '/wait_take_over',
              name: 'wait_take_over',
              component: ()=>import('@/views/procurement/take_over'),
              meta:{title:'待收货管理',unit:'采购管理'}
            },
            {
              path: '/over_take_over',
              name: 'over_take_over',
              component: ()=>import('@/views/procurement/take_over'),
              meta:{title:'已结束收货需求单',unit:'采购管理'}
            },
            {
              path: '/wait_supplier_refund',
              name: 'wait_supplier_refund',
              component: ()=>import('@/views/procurement/supplier_refund'),
              meta:{title:'待供应商退款',unit:'采购管理'}
            },
            {
              path: '/confirmed_supplier_refund',
              name: 'confirmed_supplier_refund',
              component: ()=>import('@/views/procurement/supplier_refund'),
              meta:{title:'已确认退款',unit:'采购管理'}
            },
            {
              path: '/to_be_audited',
              name: 'to_be_audited',
              component: ()=>import('@/views/procurement/pending_management'),
              meta:{title:'待审计',unit:'采购管理'}
            },
            {
              path: '/has_audited',
              name: 'has_audited',
              component: ()=>import('@/views/procurement/pending_management'),
              meta:{title:'已审计确认',unit:'采购管理'}
            },
            {
              path: '/audit_details',
              name: 'audit_details',
              component: ()=>import('@/views/procurement/audit_details'),
              meta:{title:'审计详情',unit:'采购管理'}
            },
            {
              path: '/demand_overview',
              name: 'demand_overview',
              component: ()=>import('@/views/procurement/demand_overview'),
              meta:{title:'总概况',unit:'采购管理'}
            },
            {
              path: '/item_statistics',
              name: 'item_statistics',
              component: ()=>import('@/views/procurement/item_statistics'),
              meta:{title:'品项统计',unit:'采购管理'}
            },
            {
              path: '/my_appointList',
              name: 'my_appointList',
              component: ()=>import('@/views/appointment/appointList'),
              meta:{title:'我的入库预约单',unit:'采购管理'}
            },
            {
              path: '/unaudit_appointList',
              name: 'unaudit_appointList',
              component: ()=>import('@/views/appointment/appointList'),
              meta:{title:'待审核入库预约单',unit:'采购管理'}
            },
            {
              path: '/pending_appointList',
              name: 'pending_appointList',
              component: ()=>import('@/views/appointment/appointList'),
              meta:{title:'待确认入库预约单',unit:'采购管理'}
            },
            {
              path: '/appointment_order_inbound_overview',
              name: 'appointment_order_inbound_overview',
              component: ()=>import('@/views/appointment/appointList'),
              meta:{title:'入库总览',unit:'采购管理'}
            },
            {
              path: '/database_management',
              name: 'database_management',
              component: ()=>import('@/views/database/database_list'),
              meta:{title:'资料库管理',unit:'资料库'}
            },
            {
              path: '/my_database',
              name: 'my_database',
              component: ()=>import('@/views/database/database_list'),
              meta:{title:'我的资料库',unit:'资料库'}
            },
            {
              path: '/score_manage',
              name: 'score_manage',
              component: ()=>import('@/views/matters/motivation_tools/score_manage'),
              meta:{title:'学分管理',unit:'人才发展'}
            },
            {
              path: '/auth_manage',
              name: 'auth_manage',
              component: ()=>import('@/views/matters/motivation_tools/auth_manage'),
              meta:{title:'认证管理',unit:'人才发展'}
            },
            {
              path: '/project_data',
              name: 'project_data',
              component: ()=>import('@/views/learning/project/project_data'),
              meta:{title:'数据查看',unit:'人才发展'}
            },
            {
              path: '/learn_classification',
              name: 'learn_classification',
              component: ()=>import('@/views/learning/project/learn_classification'),
              meta:{title:'培训分类',unit:'人才发展'}
            },
            {
              path: '/learn_project',
              name: 'learn_project',
              component: ()=>import('@/views/learning/project/learn_project'),
              meta:{title:'岗位地图',unit:'人才发展'}
            },
            {
              path: '/study_program',
              name: 'study_program',
              component: ()=>import('@/views/learning/project/learn_project'),
              meta:{title:'学习项目',unit:'人才发展'}
            },
            {
              path: '/onlinere_source',
              name: 'onlinere_source',
              component: ()=>import('@/views/learning/onlinere_source'),
              meta:{title:'线上资源',unit:'人才发展'}
            },
            {
              path: '/certificate_list',
              name: 'certificate_list',
              component: ()=>import('@/views/learning/certificate_list'),
              meta:{title:'证书列表',unit:'人才发展'}
            },
            {
              path: '/data_board',
              name: 'data_board',
              component: ()=>import('@/views/learning/data_board'),
              meta:{title:'数据看板',unit:'人才发展'}
            },
            {
              path: '/setting_base',
              name: 'setting_base',
              component: ()=>import('@/views/learning/setting_base'),
              meta:{title:'基础设置',unit:'人才发展'}
            },
            {
              path: '/task_send_statistics',
              name: 'task_send_statistics',
              component: ()=>import('@/views/learning/task_send_statistics'),
              meta:{title:'任务派发数据统计',unit:'人才发展'}
            },
            {
              path: '/task_data_statistics',
              name: 'task_data_statistics',
              component: ()=>import('@/views/learning/task_data_statistics'),
              meta:{title:'任务数据统计',unit:'人才发展'}
            },
            {
              path: '/cert_data_board',
              name: 'cert_data_board',
              component: ()=>import('@/views/learning/cert_data_board'),
              meta:{title:'证书数据看板',unit:'人才发展'}
            },
            {
              path: '/question_classify',
              name: 'question_classify',
              component: ()=>import('@/views/examination/question_classify'),
              meta:{title:'题库分类',unit:'人才发展'}
            },
            {
              path: '/question_manage',
              name: 'question_manage',
              component: ()=>import('@/views/examination/question_list'),
              meta:{title:'题库管理',unit:'人才发展'}
            },
            {
              path: '/shop_question',
              name: '/shop_question',
              component: ()=>import('@/views/examination/shop_question'),
              meta:{title:'门店题库',unit:'人才发展'}
            },
            {
              path: '/wrong_question_list',
              name: '/wrong_question_list',
              component: ()=>import('@/views/examination/wrong_question_list'),
              meta:{title:'全部错题',unit:'人才发展'}
            },
            {
              path: '/exam_manage_list',
              name: '/exam_manage_list',
              component: ()=>import('@/views/examination/exam_manage_list'),
              meta:{title:'试题管理',unit:'人才发展',from:'/question_manage'}
            },
            {
              path: '/practice',
              name: '/practice',
              component: ()=>import('@/views/examination/practice'),
              meta:{title:'在线练习',unit:'人才发展'}
            },
            {
              path: '/practice_record',
              name: '/practice_record',
              component: ()=>import('@/views/examination/practice_record'),
              meta:{title:'练习记录',unit:'人才发展'}
            },
            {
              path: '/initiate_exam',
              name: '/initiate_exam',
              component: ()=>import('@/views/examination/initiate_exam'),
              meta:{title:'理论考试',unit:'人才发展'}
            },
            {
              path: '/practical_exam',
              name: '/practical_exam',
              component: ()=>import('@/views/examination/practical_exam'),
              meta:{title:'实操考试',unit:'人才发展'}
            },
            {
              path: '/my_exam',
              name: '/my_exam',
              component: ()=>import('@/views/examination/my_exam'),
              meta:{title:'我的考试',unit:'人才发展'}
            },
            {
              path: '/exam_result',
              name: '/exam_result',
              component: ()=>import('@/views/examination/exam_result'),
              meta:{title:'成绩',unit:'人才发展'}
            },
            {
              path: '/feedback_list',
              name: '/feedback_list',
              component: ()=>import('@/views/learning/project/feedback_list'),
              meta:{title:'反馈列表',unit:'人才发展'}
            },
            {
              path: '/feedback_audit_list',
              name: '/feedback_audit_list',
              component: ()=>import('@/views/learning/project/feedback_audit_list'),
              meta:{title:'派发任务反馈审核',unit:'人才发展'}
            },
            {
              path: '/practice_audit_list',
              name: '/practice_audit_list',
              component: ()=>import('@/views/learning/project/feedback_audit_list'),
              meta:{title:'实操审核',unit:'人才发展'}
            },
            {
              path: '/ProductPracticeExamDashboard',
              name: '/ProductPracticeExamDashboard',
              component: ()=>import('@/views/learning/project/ProductPracticeExamDashboard'),
              meta:{title:'产品实操考试看板',unit:'人才发展'}
            },
            {
              path: '/PracticeApprovalProcess',
              name: 'PracticeApprovalProcess',
              component: ()=>import('@/views/task/taskSetting.vue'),
              meta:{title:'实操审批流程配置',unit:'人才发展'}
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: ()=>import('@/views/login/login.vue'),
      meta:{title:'登录'}
    },
    {
      path: '/in_the_exam',
      name: '/in_the_exam',
      component: ()=>import('@/views/examination/in_the_exam'),
      meta:{title:'进行考试'}
    },
    {
      path: '/view_ppt',
      name: 'view_ppt',
      component: ()=>import('@/views/login/view_ppt.vue'),
      meta:{title:'查看ppt'}
    },
    {
      path: '/view_data',
      name: 'view_data',
      component: ()=>import('@/views/database/view_data.vue'),
      meta:{title:'查看资料'}
    },
    {
      path: '/view_video',
      name: 'view_video',
      component: ()=>import('@/views/learning/view_video.vue'),
      meta:{title:'预览视频'}
    },
    {
      path: '/view_pdf',
      name: 'view_pdf',
      component: ()=>import('@/views/notify/view_pdf'),
      meta:{title:'消息详情'}
    },
    {
      path: '/map',
      name: 'map',
      component: ()=>import('@/views/login/map.vue'),
      meta:{title:'物流信息'}
    },
    {
      path: '/404',
      name: 'notFound',
      component: ()=>import('@/views/login/404.vue'),
      meta:{title:'404'}
    },{
      path:'*',
      redirect:'/404'
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   if (to.name) {
//     document.title = to.meta.title || '';
//     if (!global.userInfo.nodeid || !global.userInfo.sid || !global.userInfo.tm || !global.userInfo.sign) {
//       // 防止死循环
//       if (to.path == '/404') {
//         next()
//       } else {
//         next('/404');
//       }
//       return;
//     }else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

export default router;
